module.exports = __webpack_public_path__ + "static/media/pages4.bfe7a8d8.JPG";